import axios from 'axios'
// import { MessageBox, Message } from 'element-ui'

const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: 'http://127.0.0.1:5008',
  baseURL: '',
  timeout: 30 * 1000
})

// service.interceptors.request.use(() => {
//   // console.log('前守卫', config)
//   document.scrollingElement.scrollTop = 0
// })

// service.interceptors.response.use(response => {
//   console.log('后守卫', response)
// })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js